import ThumbDown from "./SVG/thumb-down.svg?react";

const ThumbDownIcon = () => {
  return <ThumbDown />;
};

export default ThumbDownIcon;
